import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Message, Icon, Confirm } from "semantic-ui-react";

import {
  Button,
  Pagination,
  Dimmer,
  Image,
  Loader,
  Segment,
} from "semantic-ui-react";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import { saveAs } from "file-saver";

import {
  SG_GET_FILE_UPLOADS,
  SG_DELETE_FILE_UPLOAD,
} from "constants/actions";

import format from "date-fns/format";


const UploadedList = ({
  organizationId,
  setShowReportId,
  fetchAgain,
  setFetchAgain,
  selectedTeam,
  showErrors,
  deletedRecord,
  setDeletedRecord,
  setShowPage,
  AllPageOptions,
}) => {
  const dispatch = useDispatch();
  // const [organizations, setOrganizations] = useState([]);

  const [pageLoading, setPageLoading] = useState(false);
  const [fileUploads, setFileUploads] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(false);

  const { get_file_uploads } = useSelector(
    (state) => ({
      get_file_uploads: state.fileupload,
    }),
    shallowEqual
  );

  useEffect(() => {
    // console.log("updated data", get_file_uploads.results)
    setFileUploads(get_file_uploads?.file_uploads);

    //
  }, [get_file_uploads]);

  // console.log(get_debrief_schedules.activePage)
  // console.log(activePage)

  useEffect(() => {
    let teamquery = "";
    if (selectedTeam?.id) {
      teamquery = `&team=${selectedTeam.id}`;
    }
    if (organizationId) {
      dispatch({
        type: SG_GET_FILE_UPLOADS,
        payload: `file_type=1&organization=${organizationId}${teamquery}`,
      });
    }
  }, [dispatch, organizationId, selectedTeam]);

  // console.log(organizationId, fetchAgain)

  // useEffect(() => {
  //   setPageLoading(true)
  //   const timer1 = setTimeout(() => {
  //     setPageLoading(false)
  //   }, 2000)
  //   return () => clearTimeout(timer1)
  // }, [activePage]);

  useEffect(() => {
    if (fetchAgain || deletedRecord) {
      setPageLoading(true);
    } else {
      const timer1 = setTimeout(() => {
        // if (organizationId) {
        //   dispatch({
        //     type: SG_GET_DEBRIEF_SCHEDULES,
        //     payload: `page=${activePage}&organization=${organizationId}`

        //   });
        // }
        setPageLoading(false);
      }, 2000);
      // const timer2 = setTimeout(() => {
      //     setSecondOpen(true)
      // }, 20);
      return () => clearTimeout(timer1);
      // clearTimeout(timer2)
    }
  }, [fetchAgain, deletedRecord]);

  // console.log(selectedTeam)
  useEffect(() => {
    setPageLoading(true);
    const timer1 = setTimeout(() => {
      if (fetchAgain) {
        setFetchAgain(false);
      }
      if (deletedRecord) {
        setDeletedRecord(false);
      }
      dispatch({
        type: SG_GET_FILE_UPLOADS,
        payload: `file_type=1&organization=${organizationId}`,
      });
      setPageLoading(false);
    }, 2000);
    return () => clearTimeout(timer1);
  }, [
    dispatch,
    fetchAgain,
    setFetchAgain,
    deletedRecord,
    setDeletedRecord,
    organizationId,
  ]);

  function ViewRecord(id) {
    setShowPage(AllPageOptions[1]);
    setShowReportId(id);
  }

  function clearErrors() {
    if (organizationId) {
      dispatch({
        type: SG_GET_FILE_UPLOADS,
        payload: `file_type=1&organization=${organizationId}`,
      });
    }
    setFetchAgain(false);
    setDeletedRecord(false);
  }

  function DeleteFileUpload() {
    if (deleteId) {
      dispatch({
        type: SG_DELETE_FILE_UPLOAD,
        payload: { id: deleteId },
      });
    }
    setDeletedRecord(deleteId);
    setConfirmDelete(false);
    setShowReportId(false);
    setDeleteId(false);
  }

  function SelectDeleteRow(id) {
    // console.log(id)
    setDeleteId(id);
    setConfirmDelete(true);
  }

  // console.log(deleteId)

  return (
    <ListContainer>
      {/* Success Notifications */}
      {!showErrors && fetchAgain > 0 && (
        <SuccessNotification>
          <NotificationHeader>
            <NotificationIcon>✓</NotificationIcon>
            <NotificationText>
              <NotificationTitle>Upload successful</NotificationTitle>
              <NotificationMessage>Your new upload file has been added successfully</NotificationMessage>
            </NotificationText>
          </NotificationHeader>
          <CloseButton onClick={clearErrors}>×</CloseButton>
        </SuccessNotification>
      )}

      {!showErrors && deletedRecord > 0 && (
        <SuccessNotification>
          <NotificationHeader>
            <NotificationIcon>✓</NotificationIcon>
            <NotificationText>
              <NotificationTitle>File removed</NotificationTitle>
              <NotificationMessage>The upload file has been successfully removed</NotificationMessage>
            </NotificationText>
          </NotificationHeader>
          <CloseButton onClick={clearErrors}>×</CloseButton>
        </SuccessNotification>
      )}

      {/* Loading Overlay */}
      {pageLoading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingText>Loading uploads...</LoadingText>
          </LoadingSpinner>
        </LoadingOverlay>
      )}

      {/* Modern Table */}
      <ModernTable>
        <TableHeader>
          <HeaderCell width={50}>Name</HeaderCell>
          <HeaderCell width={20}>File</HeaderCell>
          <HeaderCell width={20}>Status</HeaderCell>
          <HeaderCell width={20}>Actions</HeaderCell>
        </TableHeader>

        <TableBody>
          {fileUploads && fileUploads.length > 0 ? (
            fileUploads.map((brief, k) => {
              const saveFile = () => {
                saveAs(brief?.data_file, `${brief?.name}.csv`);
              };
              return (
                <TableRow key={k}>
                  <TableCell width={50}>
                    <FileName>{brief?.name}</FileName>
                  </TableCell>
                  
                  <TableCell width={20}>
                    <ActionButton variant="secondary" onClick={saveFile}>
                      <ButtonIcon>⬇</ButtonIcon>
                      Download
                    </ActionButton>
                  </TableCell>
                  
                  <TableCell width={20}>
                    <StatusBadge status={brief?.status_text}>
                      {brief?.status_text}
                    </StatusBadge>
                  </TableCell>
                  
                  <TableCell width={20}>
                    <ActionGroup>
                      <ActionButton variant="primary" onClick={() => ViewRecord(brief?.id)}>
                        <ButtonIcon>👁</ButtonIcon>
                        View
                      </ActionButton>
                      <DeleteButton onClick={() => SelectDeleteRow(brief?.id)}>
                        <ButtonIcon>🗑</ButtonIcon>
                      </DeleteButton>
                    </ActionGroup>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <EmptyState>
              <EmptyIcon>📁</EmptyIcon>
              <EmptyTitle>No uploads found</EmptyTitle>
              <EmptyDescription>
                Upload your first CSV file to get started
              </EmptyDescription>
            </EmptyState>
          )}
        </TableBody>
      </ModernTable>

      {/* Delete Confirmation */}
      <Confirm
        open={confirmDelete}
        onCancel={() => setConfirmDelete(false)}
        onConfirm={() => DeleteFileUpload()}
      />
    </ListContainer>
  );
};

export default UploadedList;

// Main Container
const ListContainer = styled.div`
  background: white;
  font-family: "Poppins", sans-serif;
  position: relative;
`;

// Notification Components
const SuccessNotification = styled.div`
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const NotificationHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const NotificationIcon = styled.div`
  color: #0ea5e9;
  font-size: 20px;
  line-height: 1;
  margin-top: 1px;
`;

const NotificationText = styled.div`
  flex: 1;
`;

const NotificationTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #0c4a6e;
  margin-bottom: 4px;
`;

const NotificationMessage = styled.div`
  font-size: 14px;
  color: #075985;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #0ea5e9;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e0f2fe;
  }
`;

// Loading Overlay
const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const LoadingSpinner = styled.div`
  text-align: center;
`;

const LoadingText = styled.div`
  font-size: 16px;
  color: #6b7280;
  margin-top: 16px;
`;

// Table Components
const ModernTable = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
`;

const TableHeader = styled.div`
  background: #f9fafb;
  display: flex;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
`;

const HeaderCell = styled.div`
  width: ${(props) => props.width}%;
  font-weight: 600;
  font-size: 12px;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const TableBody = styled.div`
  /* Table body container */
`;

const TableRow = styled.div`
  display: flex;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f9fafb;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.div`
  width: ${(props) => props.width}%;
  font-size: 14px;
  color: #374151;
  display: flex;
  align-items: center;
`;

const FileName = styled.div`
  font-weight: 500;
  color: #1f2937;
`;

const StatusBadge = styled.div`
  background: ${(props) => {
    if (props.status === 'Completed') return '#dcfce7';
    if (props.status === 'Processing') return '#fef3c7';
    if (props.status === 'Error') return '#fef2f2';
    return '#f3f4f6';
  }};
  color: ${(props) => {
    if (props.status === 'Completed') return '#166534';
    if (props.status === 'Processing') return '#92400e';
    if (props.status === 'Error') return '#dc2626';
    return '#374151';
  }};
  border: 1px solid ${(props) => {
    if (props.status === 'Completed') return '#bbf7d0';
    if (props.status === 'Processing') return '#fcd34d';
    if (props.status === 'Error') return '#fecaca';
    return '#e5e7eb';
  }};
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

// Action Components
const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ActionButton = styled.button`
  background: transparent;
  color: ${(props) => (props.variant === 'primary' ? '#476dfa' : '#6b7280')};
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: "Poppins", sans-serif;
  font-weight: ${(props) => (props.variant === 'primary' ? '600' : '500')};
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: ${(props) => (props.variant === 'primary' ? '#3d5ce6' : '#374151')};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DeleteButton = styled.button`
  background: transparent;
  color: #dc2626;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #b91c1c;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ButtonIcon = styled.span`
  font-size: 14px;
  line-height: 1;
`;

// Empty State
const EmptyState = styled.div`
  text-align: center;
  padding: 64px 24px;
  color: #6b7280;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
`;

const EmptyTitle = styled.h3`
  font-weight: 600;
  font-size: 18px;
  color: #374151;
  margin: 0 0 8px 0;
`;

const EmptyDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;
